document.addEventListener("change", function(e){

if(!e.target.closest("#CollectionFiltersForm")) return;

const form = document.querySelector("#CollectionFiltersForm");
const data = new FormData(form);
const params = new URLSearchParams(data).toString();

fetch(window.location.pathname + "?" + params)
.then(res => res.text())
.then(html => {

const doc = new DOMParser().parseFromString(html,"text/html");
const newProducts = doc.querySelector("#product-grid").innerHTML;

document.querySelector("#product-grid").innerHTML = newProducts;

});

});